import React, { useContext } from 'react'
import { ThemeContext } from '../../contexts/ThemeContext'
import ThemeToggleButton from '../Shared/ThemeToggleButton'

export default function SharePageHeader() {
  const themeContext = useContext(ThemeContext)
  const themeState = themeContext?.themeState

  return (
    <div className="fixed w-full z-20 top-0 border-b-2 border-rb-widget-border dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode">
      <div className="flex justify-between items-center p-2">
        <div className="flex justify-center items-center pl-2">
          <img src="/static/reachbird_logo.png" alt="Logo" className="h-6" />
          <h1 className="pl-2 text-center align-middle text-xl font-bold text-rb-black dark:text-white">Reachbird</h1>
        </div>
        <ThemeToggleButton
          isDark={themeState?.isDark}
          onToggle={() => themeState?.toggleTheme()}
          darkTitle="Vilagos mod"
          lightTitle="Sotet mod"
        />
      </div>
    </div>
  )
}
